/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it handle RNA?`)
};

const es_revcomp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Admite ARN?`)
};

const de_revcomp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird RNA unterstützt?`)
};

const nl_revcomp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werkt het met RNA?`)
};

const fr_revcomp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère-t-il l'ARN ?`)
};

const it_revcomp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisce l'RNA?`)
};

const pt_br2_revcomp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciona com RNA?`)
};

const pt_revcomp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trata sequências de ARN?`)
};

const ja_revcomp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RNAにも対応していますか？`)
};

const zh_revcomp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是否支持 RNA？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_faq_q2", locale)
	if (locale === "en") return en_revcomp_faq_q2(inputs)
	if (locale === "es") return es_revcomp_faq_q2(inputs)
	if (locale === "de") return de_revcomp_faq_q2(inputs)
	if (locale === "nl") return nl_revcomp_faq_q2(inputs)
	if (locale === "fr") return fr_revcomp_faq_q2(inputs)
	if (locale === "it") return it_revcomp_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_faq_q2(inputs)
	if (locale === "pt") return pt_revcomp_faq_q2(inputs)
	if (locale === "ja") return ja_revcomp_faq_q2(inputs)
	return zh_revcomp_faq_q2(inputs)
};